import createModel, { prop } from './lib/create_model';
const ConversationWorkflowConfig = createModel({
  modelName: 'ConversationWorkflowConfig',
  properties: {
    reopenWindow: prop(Number),
    requireTopics: prop(Boolean).default(false),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default ConversationWorkflowConfig;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/conversation_workflow_config.js